export default "__VITE_ASSET__ByOBczUD__"